// Map layer data
export const baseLayers = {
  satellite: {
    name: "Satellite",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attribution: "© Esri",
    maxZoom: 19
  },
  hybrid: {
    name: "Hybrid",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
    attribution: "© Esri",
    maxZoom: 19
  },
  terrain: {
    name: "Terrain",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
    attribution: "© Esri",
    maxZoom: 19
  },
  osm: {
    name: "OpenStreetMap",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: "© OpenStreetMap contributors",
    maxZoom: 19
  }
};

export const overlayLayers = {
  ndvi: {
    name: "NDVI",
    url: null, // Mock data, no actual URL needed
    attribution: "© Mock Data",
    tileSize: 256,
    opacity: 0.7,
    visible: false,
    instance: null
  },
  ndre: {
    name: "NDRE",
    url: null, // Mock data, no actual URL needed
    attribution: "© Mock Data",
    tileSize: 256,
    opacity: 0.7,
    visible: false,
    instance: null
  },
  evi: {
    name: "EVI",
    url: null, // Mock data, no actual URL needed
    attribution: "© Mock Data",
    tileSize: 256,
    opacity: 0.7,
    visible: false,
    instance: null
  },
  thermal: {
    name: "Thermal",
    url: null, // Mock data, no actual URL needed
    attribution: "© Mock Data",
    tileSize: 256,
    opacity: 0.7,
    visible: false,
    instance: null
  }
}; 